export const mapLocationCategoriesToApi = (data, id) => {
  return {
    data: {
      type: "locationCategories",
      ...(id && { id }),
      attributes: {
        nameAr: data.arabicName,
        nameEn: data.englishName,
        code: data.code,
      },
    },
  };
};
